/**
 * クラス名をマージするユーティリティ (shadcn/ui 標準)。
 * Tailwind のクラス競合を解決しつつ条件付きクラスを結合する。
 */

import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
